import { createSelector } from "@reduxjs/toolkit";
import { SummaryData } from "../../types/state";
import { RootState } from "src/store/rootReducer";
import { NameSpace } from "../../const";

export const getDataSummary = createSelector(
  (state: RootState) => state.vpoStrapi[NameSpace.DataSummary],
  (state: SummaryData) => state.data
);

export const getFetchingStatusMainSummary = createSelector(
  (state: RootState) => state.vpoStrapi[NameSpace.DataSummary],
  (state: SummaryData) => state.fetchingStatusSummaryData
);
